import {ObjUtil} from 'yougile-util'
import {
  DataObjectId,
  Hub,
  type StorageDepartmentHierarchy,
  Tag,
  User
} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {Sync} from '@client/sync'
import {PageService} from '@extensions/page-service'
import {Sticker} from '../sticker'

export const getTasksOnUser = (
  tasksFromMultiActions: DataObjectId[],
  usersWithTasks: {
    [userId: DataObjectId]: DataObjectId[]
  }
): {
  [userId: DataObjectId]: 'all' | 'some' | 'none'
} => {
  const tasksOnUser: {
    [userId: DataObjectId]: 'all' | 'some' | 'none'
  } = {}
  for (const [userId, tasksIds] of ObjUtil.entries(usersWithTasks)) {
    tasksOnUser[userId] = diff(tasksIds, tasksFromMultiActions)
  }
  return tasksOnUser
}

const diff = (
  a1: DataObjectId[],
  a2: DataObjectId[]
): 'all' | 'some' | 'none' => {
  const res = a1
    .filter(i => !a2.includes(i))
    .concat(a2.filter(i => !a1.includes(i)))

  if (res.length === a2.length) {
    return 'none'
  }
  if (res.length === 0) {
    return 'all'
  }
  return 'some'
}

export const getUsersWithTasks = (
  listUsers: User[],
  tasksFromMultiActions: DataObjectId[],
  sticker: Tag
): {
  [userId: DataObjectId]: DataObjectId[]
} => {
  const usersWithTasks: {
    [userId: DataObjectId]: DataObjectId[]
  } = {}
  const box = Sync.getCurrentSandbox()
  for (const id of tasksFromMultiActions) {
    const task = box.getHub(id)
    if (!task || !sticker) {
      continue
    }
    const users = Sticker.getUsers(task, sticker)
    listUsers.forEach(u => {
      if (users.includes(u.id)) {
        usersWithTasks[u.id] = [...(usersWithTasks[u.id] ?? []), task.id]
      } else {
        usersWithTasks[u.id] = [...(usersWithTasks[u.id] ?? [])]
      }
    })
  }
  return usersWithTasks
}

export const canAssignUser = (
  hub: Hub | undefined,
  userId: DataObjectId,
  calculatedHierarchy?: StorageDepartmentHierarchy
): boolean => {
  if (!hub) {
    const board = PageService.getCurrentBoard()
    if (!board) {
      return true
    }

    return PermissionsChecker.checkShow('ignore-departments', board, {
      userId,
      ignoreAdmin: true,
      calculatedHierarchy
    })
  }

  return PermissionsChecker.checkShow('ignore-departments', hub, {
    considerAsMy: true,
    considerAsWithMe: true,
    checkCanAssignUser: true,
    userId,
    ignoreAdmin: true,
    calculatedHierarchy
  })
}
